export default __webpack_public_path__ + "static/media/bg-slider.66a7ce6e.svg";